/**
 * Created by mac on 7/26/18
 */

MissionWindow = cc.Node.extend({
    ctor: function (...args) {
        this._super();

        this._windowArgs = args;
        ComponentMap.attach(this, new WindowComponent(["mission_window"]));
    },

    onWindowLoaded: function (mission, options) {
        this.withShadow = true;

        this.mission = mission;
        this.options = options || {};

        const closeWindowCallback = () => {
            ComponentMap.get(this, WindowComponent).closeWindow();
        };

        const controller = this.controller = new MissionWindowController({ mission, closeWindowCallback, ...options });
        ComponentMap.attach(this, controller);

        this.resizable = new Resizable({
            createHorizontalView: function () {
                return new RiddlesMissionViewHorizontal(controller, { closeWindowCallback });
            },
            createVerticalView: function () {
                return new RiddlesMissionViewVertical(controller, { closeWindowCallback });
            }
        });
        ComponentMap.attach(this, this.resizable);

        this.onResize();

        this.mission.updateCompetitionResults();
    },

    onResize: function () {
        const sceneSize = cleverapps.resolution.getSceneSize();
        this.setContentSize(sceneSize.width, sceneSize.height);
        this.setPosition(sceneSize.width / 2, sceneSize.height / 2);

        if (this.resizable) {
            this.resizable.onResize();
        }
    },

    onShow: function () {
        this.controller.onShow();
    },

    onClose: function () {
        this.controller.onClose();
    }
});

MissionWindow.TableRowIcons = [
    {
        type: Mission.TYPE_EXPEDITION_FEAST, icon: bundles.tablerow_icons.frames.feast_energy
    },
    {
        type: Mission.TYPE_LIVESFEAST, icon: bundles.tablerow_icons.frames.feast_energy, animation: bundles.tablerow_icons.jsons.feast_energy_animation_json, effect: "feast.row.fly"
    },
    {
        type: Mission.TYPE_SOFTFEAST, icon: bundles.tablerow_icons.frames.feast_coin, animation: bundles.tablerow_icons.jsons.feast_coin_animation_json, effect: "feast.row.fly"
    },
    {
        type: Mission.TYPE_KRAKENFEAST, icon: bundles.tablerow_icons.frames.feast_tentacle, animation: bundles.tablerow_icons.jsons.feast_tentacle_animation_json, effect: "feast.row.fly"
    }
];

MissionWindow.GetTableRowIcon = function (type) {
    const childType = Mission.GetMissionType(type);

    const tableRowIcon = MissionWindow.TableRowIcons.find(({ type }) => type === childType) || {};
    const img = cleverapps.skins.getSlot("missionTableRowIcon", { type });
    if (img) {
        tableRowIcon.icon = img;
    }
    return tableRowIcon;
};
